import Vue from 'vue'

// État partagé lu par le composant ConfirmDialog (monté une fois dans App.vue)
export const confirmState = Vue.observable({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'Confirmer',
  danger: false,
  resolve: null
})

export function askConfirm ({ title, message, confirmLabel = 'Confirmer', danger = false }) {
  return new Promise(resolve => {
    Object.assign(confirmState, { open: true, title, message, confirmLabel, danger, resolve })
  })
}

export function answerConfirm (value) {
  if (confirmState.resolve) confirmState.resolve(value)
  Object.assign(confirmState, { open: false, resolve: null })
}

Vue.prototype.$confirm = askConfirm
